interface Props {
  count: number;
  active: number;
}

/**
 * Bottom-of-carousel page dots — the active dot is wider + brighter so the count
 * stays legible at a glance even with many slides.
 */
export function PageIndicator({ count, active }: Props) {
  return (
    <div className="bg-scrim/45 absolute bottom-2 left-1/2 z-10 flex -translate-x-1/2 items-center gap-1.5 rounded-full px-2 py-1">
      {Array.from({ length: count }).map((_, index) => (
        <span
          key={index}
          className={
            index === active
              ? 'h-1.5 w-4 rounded-full bg-white transition-all'
              : 'bg-raise/50 h-1.5 w-1.5 rounded-full transition-all'
          }
          aria-hidden
        />
      ))}
    </div>
  );
}
